// extracted by mini-css-extract-plugin
export var heroWrapper = "Hero-module--heroWrapper--1bAdY";
export var authorWrapper = "Hero-module--authorWrapper--22DO0";
export var titleWrapper = "Hero-module--titleWrapper--cu0j0";
export var headerWrapper = "Hero-module--headerWrapper--2JEOu";
export var headerLangSelect = "Hero-module--headerLangSelect--1zShB";
export var imageInner = "Hero-module--imageInner--ylcF2";
export var featuredImage = "Hero-module--featuredImage--2XeLN";
export var keylineTop = "Hero-module--keylineTop--22KJp";